




















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import TradesListGroupedByPhases from '@/components/knowledge/trades/TradesListGroupedByPhases.vue';
import PMPhasesList from '@/components/knowledge/pm/phases/PMPhasesList.vue';
import { ActiveTab } from '@/components/prine/enums/ActiveTab';
import type { Phase } from '@/models/phase';
import type { Trade } from '@/models/trade';
import type { PMPhase } from '@/models/pmphase';
import XProcessesList from '@/components/knowledge/x/processes/XProcessesList.vue';
import type { XProcess } from '@/models/xprocess';
import type { Company } from '@/models/company';
import { hasAnyPermission, hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'CombinedKnowledge',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasAnyPermission, hasPermission },
    components: {
        PMPhasesList,
        XProcessesList,
        TradesListGroupedByPhases,
    },
})
export default class CombinedKnowledge extends Vue {
    @Getter('knowledge/activeTab') private activeTab: ActiveTab;

    @Prop() private phases: Phase[];
    @Prop() private originalTrades: Trade[];
    @Prop() private originalPhases: PMPhase[];
    @Prop() private originalProcesses: XProcess[];

    @Getter('account/company') private company: Company;
    @Getter('utils/currentLocale') private currentLocale: string;

    get activeTabIndex() {
        return this.activeTab;
    }

    // noinspection JSUnusedGlobalSymbols
    set activeTabIndex(index: number) {
        this.$store.commit('knowledge/setActiveTab', index);
    }
}
